import React, { useState, useMemo } from 'react';
import { Box } from '@mui/material';
import { useChatsWithAnnotations } from '@/hooks/useChannelAnnotations';
import { ChatThemeProvider } from './ChatThemeContext';
import ChatSidebar from './components/ChatSidebar';
import MessagePanel from './components/MessagePanel';

const ChatPreviewPage: React.FC = () => {
  // Unfiltered: "manuscript only" is a sidebar filter now, not a hidden query.
  const { data: chats = [], isLoading } = useChatsWithAnnotations(false);
  const [selectedChatId, setSelectedChatId] = useState<number | null>(null);

  const selectedChat = useMemo(
    () => chats.find((c) => c.id === selectedChatId) || null,
    [chats, selectedChatId]
  );

  return (
    <ChatThemeProvider>
      <Box
        sx={{
          position: 'fixed',
          top: 64, // AppBar height
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <ChatSidebar
          chats={chats}
          selectedChatId={selectedChatId}
          onSelectChat={setSelectedChatId}
          isLoading={isLoading}
        />
        <MessagePanel chatId={selectedChatId} chat={selectedChat} />
      </Box>
    </ChatThemeProvider>
  );
};

export default ChatPreviewPage;
